import { render, staticRenderFns } from "./InvestorFunnelColumn.vue?vue&type=template&id=27550074&scoped=true&"
import script from "./InvestorFunnelColumn.vue?vue&type=script&lang=js&"
export * from "./InvestorFunnelColumn.vue?vue&type=script&lang=js&"
import style0 from "./InvestorFunnelColumn.vue?vue&type=style&index=0&id=27550074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27550074",
  null
  
)

export default component.exports